export default __webpack_public_path__ + "static/media/a6.0c185c35.png";